import React from "react";
import { Rings } from "react-loader-spinner";

const index = () => {
  return (
    <>
      <div className="w-full h-screen bg-surface-muted flex justify-center items-center">
        <div className="loader-div ">
          <Rings
            visible={true}
            height="80"
            width="80"
            color="rgb(var(--color-primary))"
            ariaLabel="rings-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      </div>
    </>
  );
};

export default index;
